<template>
  <el-dialog
    title="添加设备"
    :append-to-body="true"
    :before-close="closeView"
     :close-on-click-modal="false"
     class="addSingleDeviceView"
      :visible.sync="singleVisible"
      width="600px">
      <!-- <span slot="title" class="dialog-footer">
        <span>添加设备</span>
        <el-tooltip :content="addDeviceTips" placement="right" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </span> -->
      <div class="tips">
        <div><span class="el-icon-info"></span></div>
        <div>
          <span class="">特别说明： 设备名 可以为空，当为空时，会颁发全局唯一标识符作为 设备名</span>
        </div>
      </div>
      <el-form ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="产品" prop="addProductKey">
          <el-select v-model="form.addProductKey" placeholder="请选择" size="small">
              <el-option
                v-for="item in productList"
                :key="item.productKey"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="设备标识符" prop="singleDeviceName">
          <template>
            <el-tooltip :content="deviceNameTips" placement="right" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </template>
           <el-input maxlength="20" v-model.trim="form.singleDeviceName" placeholder="请输入设备标识符" size="small"></el-input>
        </el-form-item>

          <!-- <el-row>
            设备标识符
            <el-tooltip :content="deviceNameTips" placement="right" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </el-row>
          <el-row>
            <el-input v-model="form.singleDeviceName" placeholder="请输入设备标识符" size="small"></el-input>
          </el-row> -->

          <el-form-item label="设备昵称" prop="singleNickName">
          <!-- <template slot="label">
            <span>
               设备昵称
            <el-tooltip :content="nickNameTips" placement="right" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
            </span>
          </template> -->
            <template>
              <el-tooltip :content="nickNameTips" placement="right" effect="light">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
            <el-input maxlength="20" v-model.trim="form.singleNickName" placeholder="请输入设备昵称" size="small"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="addSingleDevice" size="small">确 定</el-button>
        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { addDevice } from '@/api/deviceManagement'
export default {
  props: {
    singleVisible: {
      type: Boolean
    },
    productList: {
      type: Array || null
    },
    singleAddDetail: {
      type: Object
    }
  },
  data: function () {
    var validateDeviceName = (rule, value, callback) => {
      if (value && value.length < 4) {
        callback(new Error('至少输入4个字符！'))
      }
      if (!/^[A-Za-z0-9_-]+$/.test(value)) {
        callback(new Error('请输入英文字母、数字、下划线（_）、中划线（-）'))
      } else {
        callback()
      }
    }

    var validateSingleNickName = (rule, value, callback) => {
      if (value && value.length < 4) {
        callback(new Error('至少输入4个字符！'))
      }
      if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value)) {
        callback(new Error('请输入中文、数字和英文！'))
      } else {
        callback()
      }
    }

    return {
      form: {
        addProductKey: '',
        singleNickName: '',
        singleDeviceName: ''
      },
      deviceNameTips: '支持英文字母、数字、下划线（_）、中划线（-），长度限制为4~20个字符',
      addDeviceTips: '创建设备后可以使用平台颁发的身份信息连接到平台，详细说明请参考',
      nickNameTips: '支持中文、英文字母、数字，长度限制4~20个字符',
      rules: {
        addProductKey: [
          { required: true, message: '请选择产品', trigger: 'change' }
        ],
        singleDeviceName: [
          { required: true, message: '请输入设备标识符', trigger: 'blur' },
          { validator: validateDeviceName, trigger: 'change' }
        ],
        singleNickName: [
          { validator: validateSingleNickName, trigger: 'change' },
          { required: true, message: '请输入设备昵称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    singleVisible () {
      console.log('变化了')
      this.$nextTick(function () {
        this.$refs.ruleForm.resetFields()
      })
    }
  },
  methods: {
    closeView () {
      this.$emit('closeView')
    },
    addSingleDevice () {
      this.$refs.ruleForm.validate((valid) => {
        console.log('valid:', valid)
        if (valid) {
          // this.updateRole()
          const params = {
            addType: 0, // 0:表示添加单个设备，1：表示添加多个设备
            nickName: this.form.singleNickName,
            productKey: this.form.addProductKey
          }
          if (this.form.singleDeviceName) {
            params.deviceName = this.form.singleDeviceName
          }
          const code = this.$httpCode
          console.log('添加单个设备发送参数：', params)
          addDevice(params).then(res => {
            res = res.data
            console.log('添加单个设备返回：', res)
            if (res.code === code.SUCCESS) {
              // 作为一键复制设备证书的原始数据
              this.singleAddDetail.deviceSecret = {
                productKey: this.form.addProductKey,
                deviceName: res.data.deviceName,
                deviceSecret: res.data.deviceSecret
              }
              this.singleAddDetail.addSingleDetail = res.data
              console.log('单个设备添加成功：', JSON.stringify(this.singleAddDetail))
              this.closeView()// 关闭弹窗
              this.$emit('openSingleSuccessView')
              this.$emit('getDeviceList')
            } else {
              this.$message.error('设备添加失败')
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scope>
.addSingleDeviceView{
  .star{
       color:#d93026;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .el-row:nth-child(even){
      margin-top: 15px;
    }
    .el-row:nth-child(odd){
      margin-top: 5px;
    }
    .el-select{
      width: 100%;
    }
    .el-icon-info{
      color: #0070cc;
      margin-right: 10px;
      font-size: 16px;
    }
    .tips{
      padding: 15px;
      display: flex;
      background-color: #e5f3ff;
      font-size: 10px;
    }
  }
</style>
